/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
  Box,
  Select,
  Switch,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { MyProfileContext } from '../context';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAiSuggestedIntro,
  clearSuggestion,
} from 'v4/store/actions/user-profile.actions';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import EditorConvertToHTML from 'v4/components/common/Editor';
import { EarthGlobeIcon, TeamIcon, OnlyMeLockIcon } from '@mybridge/icons';
import _ from 'lodash';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyProfileIntroductionModal = forwardRef(
  ({ noHeadline, nonModal, ...props }, ref) => {
    const stripHtmlTags = (htmlContent) => {
      if (!htmlContent) return '';
      // Remove all HTML tags using regex
      return htmlContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    };
    const dispatch = useDispatch();
    const { t } = useTranslator();
    const { formatNumber } = useNumberFormatter();
    const { suggestedData, isLoading } =
      useSelector((state) => state.userProfile) ?? {};
    const [aiSuggestions, setAiSuddestions] = useState(false);
    const [occupationAI, setOccupationAI] = useState();
    const [targetAI, setTargetAI] = useState();
    const [actionAI, setActionsAI] = useState();
    const [toneAI, setToneAI] = useState('formal');
    const [emojiAI, setEmojiAI] = useState(false);
    const {
      introductionDisc,
      profileUpdateLoading,
      userProfileInfo,
      updateIntroduction,
      audienceDisc,
      setPermissionValue,
    } = useContext(MyProfileContext);

    const {
      register,
      handleSubmit,
      watch,
      setValue,
      getValues,
      formState: { errors },
    } = useForm();

    const onSubmit = async (form) => {
      const payload = {
        profile_headline: form?.headline,
        profile_intro: stripHtmlTags(form?.intro), // Strip HTML tags before saving
      };
      await updateIntroduction(payload);
      await dispatch(clearSuggestion());
    };

    const getAiSuggestions = () => {
      const payload = {
        input: occupationAI,
        // target: targetAI,
        // action: actionAI,
        // tone: toneAI,
        // emojis: emojiAI,
      };
      dispatch(getAiSuggestedIntro(payload));
    };

    const introValue = _.get(userProfileInfo, 'field_audience.profile_intro');
    // console.log(targetAI);

    const renderPermissionSwitch = (param) => {
      switch(param) {
        case 1:
          return {icon: <EarthGlobeIcon width="16px" height="16px" />, text: t('profileDetails.public') || 'Public'};
        case 2:
          return {icon: <TeamIcon width="16px" height="16px" />, text: t('profileDetails.myNetwork') || 'myNetwork'};
        case 3:
          return {icon: <OnlyMeLockIcon width="16px" height="16px" />, text: t('profileDetails.onlyMe') || 'Only me'};
        default:
          return {icon: <EarthGlobeIcon width="16px" height="16px" />, text: t('profileDetails.public') || 'Public'};
      }
    }
    
    const { profile_headline, profile_intro } = userProfileInfo ?? {};
    
    useEffect(() => {
      setValue('intro', profile_intro);
    }, [profile_intro, setValue])


    return (
      <>
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={4}>
                {!aiSuggestions ? (
                  <>
                    {!noHeadline && (
                      <FormControl
                        isInvalid={errors?.headline}
                        variant="floating"
                      >
                        
                        <Input
                          defaultValue={profile_headline}
                          {...register('headline', {
                            required: noHeadline ? true : false,
                          })}
                          placeholder=""
                        />
                        <FormLabel>{t('profileDetails.profileHeadline') || 'Profile Headline'}</FormLabel>
                        <FormErrorMessage>
                          {t('profileDetails.headlineRequired') || 'Headline is required'}
                        </FormErrorMessage>
                      </FormControl>
                    )}

                    <FormControl isInvalid={errors?.intro}>
                      {/* <FormLabel>About you</FormLabel> */}
                      <EditorConvertToHTML
                        toolbardropDown={false}
                        hideToolbar={true}
                        {...register('intro', {
                          required: true,
                          validate: (value) => {
                            const textLength = stripHtmlTags(value)?.length || 0;
                            return textLength <= 2000 || `Content must be 2000 characters or less`;
                          }
                        })}
                        setEditorData={(event) => {
                          setValue('intro', event);
                        }}
                        defaultValue={profile_intro}
                        placeholder={t('profileDetails.writeDetailsAboutYourself') || 'Write some details about yourself'}
                        editorClass={'event-textarea custom-editor'}
                      />
                      <FormHelperText as={HStack} justifyContent="flex-end">
                        <Text color={stripHtmlTags(watch('intro'))?.length > 2000 ? 'red.500' : 'inherit'}>
                           {formatNumber(stripHtmlTags(watch('intro'))?.length || 0)}/{formatNumber(2000)}
                        </Text>
                      </FormHelperText>
                      <FormErrorMessage>
                        {errors?.intro?.message || (t('profileDetails.introductionDescriptionRequired') || 'Introduction description is required ')}
                      </FormErrorMessage>
                    </FormControl>
                  </>
                ) : (
                  <>
                    <FormControl>
                      <FormLabel>{t('profileDetails.writeFewWordsAboutYou') || 'Write in few words about you.'}</FormLabel>
                      <Textarea
                        variant="primary"
                        placeholder={t('profileDetails.profileExample')||"ex: Developer at myBridge.me, developed a tool that helps you grow on myBridge"}
                        onChange={(e) => setOccupationAI(e.target.value)}
                        value={occupationAI}
                      />
                    </FormControl>
                    <Box>{!isLoading ? suggestedData : <SectionLoader />}</Box>
                  </>
                )}
              </Stack>
              {isMobile&&(<HStack>
                  <Button
                  borderRadius="50px"
                    type="button"
                    onClick={() => {audienceDisc.onOpen(); setPermissionValue('profile_intro')}}
                    leftIcon={renderPermissionSwitch(introValue)?.icon}
                  >
                    {renderPermissionSwitch(introValue)?.text}
                  </Button>
                </HStack>)}
              <HStack justifyContent="space-between" mt={6}>
               { !isMobile&&(<HStack>
                  <Button
                    type="button"
                    borderRadius="full"
                    onClick={() => {audienceDisc.onOpen(); setPermissionValue('profile_intro')}}
                    leftIcon={renderPermissionSwitch(introValue)?.icon}
                  >
                    {renderPermissionSwitch(introValue)?.text}
                  </Button>
                </HStack>)}

                <HStack>
                {aiSuggestions ? (
                      <>
                        <Button
                          isLoading={isLoading}
                          type="button"
                          variant="transparent"
                          onClick={() => getAiSuggestions()}
                        >
                          {suggestedData ? t('buttons.regenerate')||'Regenerate' : t('buttons.generate')||'Generate'}
                        </Button>
                        <HStack>
                          <Button
                            onClick={() => setAiSuddestions((prev) => !prev)}
                            variant="secondary"
                            borderRadius="full"
                          >
                            {t('buttons.cancel') || 'Cancel'}
                          </Button>
                          <Button
                            isLoading={profileUpdateLoading}
                            variant="primary"
                            borderRadius="full"
                            isDisabled={!occupationAI}
                            onClick={() => {
                              setValue('intro', suggestedData);
                              setAiSuddestions(false);
                            }}
                          >
                            {t('buttons.addToProfile') || 'Add to Profile'}
                          </Button>
                        </HStack>
                      </>
                    ) : (
                      <>
                        <Button
                          isLoading={profileUpdateLoading}
                          borderRadius="full"
                          type="button"
                          variant="transparent"
                          onClick={() => setAiSuddestions((prev) => !prev)}
                        >
                          {t('buttons.getAISuggestions') || 'Get AI suggestions'}
                        </Button>
                        <HStack>
                          <Button
                            onClick={(e) => introductionDisc?.onClose?.()}
                            variant="secondary"
                            borderRadius="50px"
                          >
                            {t('buttons.cancel') || 'Cancel'}
                          </Button>
                          <Button
                            isLoading={profileUpdateLoading}
                            type="submit"
                            variant="primary"
                            borderRadius="50px"
                            isDisabled={!stripHtmlTags(watch('intro'))?.trim()?.length || stripHtmlTags(watch('intro'))?.length > 2000}
                          >
                            {t('buttons.save') || 'Save'}
                          </Button>
                        </HStack>
                      </>
                    )}
                  {/* <Button
                    onClick={(e) => introductionDisc?.onClose?.()}
                    variant="secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    isLoading={profileUpdateLoading}
                    type="submit"
                    variant="primary"
                  >
                    Save
                  </Button> */}
                </HStack>
              </HStack>
            </form>
          </>
       
      </>
    );
  }
);
